import tableRelatedMainHubThirdPartyProvider from './tableRelatedMainHubThirdPartyProvider';

export default {
  title: 'Third Party Providers',
  attributeName: 'thirdPartyProviders',
  getURL: 'mainHubs/mainHubId/configId/thirdPartyProviders',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: ['mainHubId', 'configId'],
  tableConfig: tableRelatedMainHubThirdPartyProvider ,
};

